// This module can be bundled into a package for better reusability.
const axios = require('axios');
const { getEnvironmentFromUrl } = require('@nuskin/ns-common-lib');
const config = require('./environment');

// contentstack HTTP service
const platform = usePlatformSpecificVariables();
const http = axios.create({ baseURL: platform.baseURL, headers: platform.headers });

// usePlatformVariables returns an object with platform-specific values; defaults to Lambda environment
function usePlatformSpecificVariables() {
  if (typeof window !== 'undefined') {
    return useWebEnvironment();
  }

  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return useMobileEnvironment();
  }

  return useLambdaEnvironment();
}

function useWebEnvironment() {
  const env = getEnvironmentFromUrl(window.location.host);
  const envConfig = config.getCredentials(env);
  const baseURL = `${envConfig.url}/stacks/${envConfig.apiKey}?environment=${envConfig.env}`;
  const headers = {
    'access_token': `${envConfig.accessToken}`,
    'Content-Type': 'application/json'
  };

  return { baseURL, env, headers }
}

function useMobileEnvironment() {
  // ...
}

function useLambdaEnvironment() {
  console.log('lambda');
  const env = {};
  const baseURL = `contentstack-call-for-lambda`;
  const headers = {
    'access_token': `contentstack-access-token-for-lambda`,
    'Content-Type': 'application/json'
  };

  return { baseURL, env, headers }
}


// in-memory caching
const cacheKeys = { aemConfig: 'aemConfig', equinoxMarkets: 'equinoxMarkets', kongUrl: 'kongUrl' };
const cacheTTLInSeconds = 30 * 1000;
const cache = {
  [cacheKeys.aemConfig]: { data: null, ttl: Date.now() + cacheTTLInSeconds },
  [cacheKeys.equinoxMarkets]: { data: null, ttl: Date.now() + cacheTTLInSeconds },
  [cacheKeys.kongUrl]: { data: null, ttl: Date.now() + cacheTTLInSeconds }
};

/**
 * isCacheExpired checks if the cached data is expired.
 *
 * @param {string} key
 * @returns {boolean}
 */
function isCacheExpired(key) {
  return cache[key].data === null || Date.now() > cache[key].ttl;
}

/**
 * setCachedData will replace the cached data and update the TTL.
 *
 * @param {string} key
 * @param {MarketConfig|EquinoxEnabledMarkets} data
 * @returns {void}
 */
function setCachedData(key, data) {
  cache[key].data = data;
  cache[key].ttl = Date.now() + cacheTTLInSeconds;
}

/**
 * getCachedData returns the cached data.
 *
 * @param {string} key
 */
function getCachedData(key) {
  return cache[key].data;
}

/**
 * getAEMConfig fetches the market config from contentstack.
 *
 * @typedef MarketConfig
 * @property {string} aws_url
 * @property {string} checkout_client_id
 * @property {string} checkout_client_secret
 *
 * @export
 * @return {Promise<null|MarketConfig>}
 */
async function getAEMConfig() {
  try {
    if (isCacheExpired(cacheKeys.aemConfig)) {
      const marketConfig = `market_config_${platform.env}`;
      const variables = { uid: 'blt52b0b83a89763791' };
      const query = `query AemConfigByUid($uid: String!) {
        aem_config(uid: $uid) {
          title
          ${marketConfig} {
            checkout_client_secret
            checkout_client_id
            aws_url
          }
        }
      }`;

      const { data } = await contentstackService({
        data: { variables, query }
      });

      setCachedData(cacheKeys.aemConfig, data.aem_config[marketConfig]);
    }

    return getCachedData(cacheKeys.aemConfig);
  } catch (error) {
    console.error(error);
    return null;
  }
}

/**
 * Contentstack HTTP - axios wrapper for contentstack request
 *
 * @param {Object} config  - required param
 * @return {Promise<import('axios').AxiosResponse>}  Promise that resolves to market_list_eq object
 */
async function contentstackService(config) {
  const data = JSON.parse(JSON.stringify(config.data));

  try {
    const response = await http.post('', data);
    console.log(response);
    return response.data
  } catch (error) {
    console.error(error.response.data.errors);
  }
}

module.exports = {
  getAEMConfig
}
